export default "__VITE_ASSET__D8w5XDiz__";